import { actionCreator } from 'utils';
import * as OrderTypes from '../types/orderTypes';

// L O A D   O R D E R S
export function loadOrders() {
    return {
        type: OrderTypes.LOAD_ORDERS,
    };
}

export function loadOrdersRes(data, neededCRMData) {
    return {
        type: actionCreator(OrderTypes.LOAD_ORDERS, 'res'),
        data,
        neededCRMData,
    };
}

export function loadOrdersErr() {
    return {
        type: actionCreator(OrderTypes.LOAD_ORDERS, 'err'),
    };
}
// L O A D   O R D E R S

// S E T   O R D E R S   F I L T E R S,   P A G I N A T I O N,   S O R T   &   R E S E T   F I L T E R S
export function setOrdersFilters(key, value) {
    return {
        type: OrderTypes.SET_ORDERS_FILTER,
        key,
        value,
    };
}

export function resetOrdersFilters() {
    return {
        type: OrderTypes.RESET_ORDERS_FILTERS,
    };
}

export function setOrdersPagination(key, pagination) {
    return {
        type: OrderTypes.SET_ORDERS_PAGINATION,
        key,
        pagination,
    };
}

export function setOrdersSort(sort) {
    return {
        type: OrderTypes.SET_ORDERS_SORT,
        sort,
    };
}
// S E T   O R D E R S   F I L T E R S,   P A G I N A T I O N,   S O R T   &   R E S E T   F I L T E R S

// L O A D   O R D E R
export function loadOrder(id) {
    return {
        type: OrderTypes.LOAD_ORDER,
        id,
    };
}

export function loadOrderRes(data) {
    return {
        type: actionCreator(OrderTypes.LOAD_ORDER, 'res'),
        data,
    };
}

export function loadOrderErr() {
    return {
        type: actionCreator(OrderTypes.LOAD_ORDER, 'err'),
    };
}

export function resetOrdersInfo() {
    return {
        type: OrderTypes.RESET_ORDERS_INFO,
    };
}

export function setNeededData(data) {
    return {
        type: OrderTypes.SET_NEEDED_DATA,
        data,
    };
}
// L O A D   O R D E R

// E D I T   S H I P P I N G   T Y P E
export function editShippingTypesOrder(data) {
    return {
        type: OrderTypes.EDIT_SHIPPING_TYPE_ORDER,
        data,
    };
}

export function editShippingTypesOrderRes(loading, success) {
    return {
        type: actionCreator(OrderTypes.EDIT_SHIPPING_TYPE_ORDER, 'res'),
        loading,
        success,
    };
}

export function editShippingTypesOrderErr() {
    return {
        type: actionCreator(OrderTypes.EDIT_SHIPPING_TYPE_ORDER, 'err'),
    };
}
// E D I T   S H I P P I N G   T Y P E

// O R D E R   T O   R E C E I V E D
export function orderToReceive(data) {
    return {
        type: OrderTypes.ORDER_TO_RECEIVED,
        data,
    };
}

export function orderToReceiveRes(loading, success) {
    return {
        type: actionCreator(OrderTypes.ORDER_TO_RECEIVED, 'res'),
        loading,
        success,
    };
}

export function orderToReceiveErr() {
    return {
        type: actionCreator(OrderTypes.ORDER_TO_RECEIVED, 'err'),
    };
}
// O R D E R   T O   R E C E I V E D

// C L O N E   O R D E R   I T E M
export function cloneOrderItem(data, addresses, orderId, clonedItemId) {
    return {
        type: OrderTypes.CLONE_ORDER_ITEM,
        data,
        addresses,
        orderId,
        clonedItemId,
    };
}
export function cloneOrderItemRes(payload) {
    return {
        type: actionCreator(OrderTypes.CLONE_ORDER_ITEM, 'res'),
        payload,
    };
}

export function cloneOrderItemErr(error) {
    return {
        type: actionCreator(OrderTypes.CLONE_ORDER_ITEM, 'err'),
        error,
    };
}
// C L O N E   O R D E R   I T E M

// D E L E T E   O R D E R   I T E M
export function deleteOrderItem(orderItemId, orderReference) {
    return {
        type: OrderTypes.DELETE_ORDER_ITEM,
        orderItemId,
        orderReference,
    };
}

export function deleteOrderItemRes(payload) {
    return {
        type: actionCreator(OrderTypes.DELETE_ORDER_ITEM, 'res'),
        payload,
    };
}

export function deleteOrderItemErr(error) {
    return {
        type: actionCreator(OrderTypes.DELETE_ORDER_ITEM, 'err'),
        error,
    };
}
// D E L E T E   O R D E R   I T E M

// R E   P R I N T   O R D E R   I T E M
export function reprintOrderItem(orderItemId, inputTextArea, inputReason) {
    return {
        type: OrderTypes.REPRINT_ORDER_ITEM,
        orderItemId,
        inputTextArea,
        inputReason,
    };
}

export function reprintOrderItemRes(loading, success) {
    return {
        type: actionCreator(OrderTypes.REPRINT_ORDER_ITEM, 'res'),
        loading,
        success,
    };
}

export function reprintOrderItemErr(error) {
    return {
        type: actionCreator(OrderTypes.REPRINT_ORDER_ITEM, 'err'),
        error,
    };
}
// R E   P R I N T   O R D E R   I T E M


// C A N C E L   O R D E R
export function cancelOrder(orderId, orderReference) {
    return {
        type: OrderTypes.CANCEL_ORDER,
        orderId,
        orderReference,
    };
}

export function cancelOrderRes(loading, success) {
    return {
        type: actionCreator(OrderTypes.CANCEL_ORDER, 'res'),
        loading,
        success,
    };
}

export function cancelOrderErr(error) {
    return {
        type: actionCreator(OrderTypes.CANCEL_ORDER, 'err'),
        error,
    };
}
// C A N C E L   O R D E R

// C L O N E   O R D E R
export function cloneOrder(data) {
    return {
        type: OrderTypes.CLONE_ORDER,
        data,
    };
}

export function cloneOrderRes(loading, success) {
    return {
        type: actionCreator(OrderTypes.CLONE_ORDER, 'res'),
        loading,
        success,
    };
}

export function cloneOrderErr(error) {
    return {
        type: actionCreator(OrderTypes.CLONE_ORDER, 'err'),
        error,
    };
}
// C L O N E   O R D E R


// S E T   C H E C K E D   O R D E R  I T E M S
export function setCheckedOrderItems(id) {
    return {
        type: OrderTypes.SET_CHECKED_ORDER_ITEMS,
        id,
    };
}
// S E T   C H E C K E D   O R D E R  I T E M S


// S E T   C O M M E N T   O R D E R  I T E M
export function setOrderItemComment(data) {
    return {
        type: OrderTypes.SET_COMMENT_ORDER_ITEMS,
        data,
    };
}

export function setOrderItemCommentRes(loading, success) {
    return {
        type: actionCreator(OrderTypes.SET_COMMENT_ORDER_ITEMS, 'res'),
        loading,
        success,
    };
}

export function setOrderItemCommentErr(error) {
    return {
        type: actionCreator(OrderTypes.SET_COMMENT_ORDER_ITEMS, 'err'),
        error,
    };
}
// S E T   C O M M E N T   O R D E R  I T E M


// A D D   L I N K   O R D E R  I T E M
export function addOrderItemLink(data) {
    return {
        type: OrderTypes.ADD_LINK_ORDER_ITEMS,
        data,
    };
}

export function addOrderItemLinkRes(loading, success) {
    return {
        type: actionCreator(OrderTypes.ADD_LINK_ORDER_ITEMS, 'res'),
        loading,
        success,
    };
}

export function addOrderItemLinkErr(error) {
    return {
        type: actionCreator(OrderTypes.ADD_LINK_ORDER_ITEMS, 'err'),
        error,
    };
}
// A D D   L I N K   O R D E R  I T E M


// A D D   D O C U M E N T   O R D E R   I T E M
export function addOrderItemDocument(data) {
    return {
        type: OrderTypes.ADD_DOCUMENT_ORDER_ITEMS,
        data,
    };
}

export function addOrderItemDocumentRes(loading, success) {
    return {
        type: actionCreator(OrderTypes.ADD_DOCUMENT_ORDER_ITEMS, 'res'),
        loading,
        success,
    };
}

export function addOrderItemDocumentErr(error) {
    return {
        type: actionCreator(OrderTypes.ADD_DOCUMENT_ORDER_ITEMS, 'err'),
        error,
    };
}
// A D D   D O C U M E N T   O R D E R   I T E M

// D E L E T E   D O C U M E N T   O R D E R   I T E M
export function deleteOrderItemDocument(data) {
    return {
        type: OrderTypes.DELETE_DOCUMENT_ORDER_ITEMS,
        data,
    };
}

export function deleteOrderItemDocumentRes(loading, success) {
    return {
        type: actionCreator(OrderTypes.DELETE_DOCUMENT_ORDER_ITEMS, 'res'),
        loading,
        success,
    };
}

export function deleteOrderItemDocumentErr(error) {
    return {
        type: actionCreator(OrderTypes.DELETE_DOCUMENT_ORDER_ITEMS, 'err'),
        error,
    };
}
// D E L E T E   D O C U M E N T   O R D E R   I T E M

// D E L E T E   L I N K   O R D E R  I T E M S
export function deleteOrderItemLink(data) {
    return {
        type: OrderTypes.DELETE_LINK_ORDER_ITEMS,
        data,
    };
}

export function deleteOrderItemLinkRes(loading, success) {
    return {
        type: actionCreator(OrderTypes.DELETE_LINK_ORDER_ITEMS, 'res'),
        loading,
        success,
    };
}

export function deleteOrderItemLinkErr(error) {
    return {
        type: actionCreator(OrderTypes.DELETE_LINK_ORDER_ITEMS, 'err'),
        error,
    };
}
// D E L E T E   L I N K   O R D E R  I T E M S

// A D D   N E W   O R D E R
export function addNewOrder(data) {
    return {
        type: OrderTypes.ADD_NEW_ORDER,
        data,
    };
}

export function addNewOrderRes(data) {
    return {
        type: actionCreator(OrderTypes.ADD_NEW_ORDER, 'res'),
        data,
    };
}

export function addNewOrderErr() {
    return {
        type: actionCreator(OrderTypes.ADD_NEW_ORDER, 'err'),
    };
}
// A D D   N E W   O R D E R


// E D I T   O R D E R
export function editOrder(data) {
    return {
        type: OrderTypes.EDIT_ORDER,
        data,
    };
}

export function editOrderRes() {
    return {
        type: actionCreator(OrderTypes.EDIT_ORDER, 'res'),
    };
}

export function editOrderErr() {
    return {
        type: actionCreator(OrderTypes.EDIT_ORDER, 'err'),
    };
}
// E D I T   O R D E R


// A D D   N E W   O R D E R   I T E M
export function addNewOrderItem(data, view) {
    return {
        type: OrderTypes.ADD_NEW_ORDER_ITEM,
        data,
        view,
    };
}

export function addNewOrderItemRes(loading, success) {
    return {
        type: actionCreator(OrderTypes.ADD_NEW_ORDER_ITEM, 'res'),
        loading,
        success,
    };
}

export function addNewOrderItemErr() {
    return {
        type: actionCreator(OrderTypes.ADD_NEW_ORDER_ITEM, 'err'),
    };
}
// A D D   N E W   O R D E R   I T E M


// E D I T   O R D E R   I T E M
export function editOrderItem(data) {
    return {
        type: OrderTypes.EDIT_ORDER_ITEM,
        data,
    };
}

export function editOrderItemRes(loading, success) {
    return {
        type: actionCreator(OrderTypes.EDIT_ORDER_ITEM, 'res'),
        loading,
        success,
    };
}

export function editOrderItemErr() {
    return {
        type: actionCreator(OrderTypes.EDIT_ORDER_ITEM, 'err'),
    };
}
// E D I T   O R D E R   I T E M


// A D D   N E W   A D D I T I O N A L   I T E M
export function addAdditionalItem(data) {
    return {
        type: OrderTypes.ADD_ADDITIONAL_ITEM,
        data,
    };
}

export function addAdditionalItemRes(loading, success) {
    return {
        type: actionCreator(OrderTypes.ADD_ADDITIONAL_ITEM, 'res'),
        loading,
        success,
    };
}

export function addAdditionalItemErr() {
    return {
        type: actionCreator(OrderTypes.ADD_ADDITIONAL_ITEM, 'err'),
    };
}
// A D D   N E W   A D D I T I O N A L   I T E M


// D E L E T E  A D D I T I O N A L   I T E M
export function deleteAdditionalItem(data) {
    return {
        type: OrderTypes.DELETE_ADDITIONAL_ITEM,
        data,
    };
}

export function deleteAdditionalItemRes() {
    return {
        type: actionCreator(OrderTypes.DELETE_ADDITIONAL_ITEM, 'res'),
    };
}

export function deleteAdditionalItemErr() {
    return {
        type: actionCreator(OrderTypes.DELETE_ADDITIONAL_ITEM, 'err'),
    };
}
// D E L E T E   A D D I T I O N A L   I T E M

// S E T   E X P E C T E D   S H I P P I N G   D A T E
export function setExpectedShippingDate(data) {
    return {
        type: OrderTypes.SET_EXPECTED_SHIPPING_DATE,
        data,
    };
}

export function setExpectedShippingDateRes(loading, success) {
    return {
        type: actionCreator(OrderTypes.SET_EXPECTED_SHIPPING_DATE, 'res'),
        loading,
        success,
    };
}

export function setExpectedShippingDateErr() {
    return {
        type: actionCreator(OrderTypes.SET_EXPECTED_SHIPPING_DATE, 'err'),
    };
}
// S E T   E X P E C T E D   S H I P P I N G   D A T E


//  A D D   N E W   F A V O R I S   O R D E R
export function addNewFavorisOrder(data) {
    return {
        type: OrderTypes.ADD_NEW_FAVORIS_ORDER,
        data,
    };
}

export function addNewFavorisOrderRes(loading, success) {
    return {
        type: actionCreator(OrderTypes.ADD_NEW_FAVORIS_ORDER, 'res'),
        loading,
        success,
    };
}

export function addNewFavorisOrderErr() {
    return {
        type: actionCreator(OrderTypes.ADD_NEW_FAVORIS_ORDER, 'err'),
    };
}
//  A D D   N E W   F A V O R I S   O R D E R


//  D E L E T E   F A V O R I S   O R D E R
export function deleteFavorisOrder(data) {
    return {
        type: OrderTypes.DELETE_FAVORIS_ORDER,
        data,
    };
}

export function deleteFavorisOrderRes(loading, success) {
    return {
        type: actionCreator(OrderTypes.DELETE_FAVORIS_ORDER, 'res'),
        loading,
        success,
    };
}

export function deleteFavorisOrderErr() {
    return {
        type: actionCreator(OrderTypes.DELETE_FAVORIS_ORDER, 'err'),
    };
}
//  D E L E T E   F A V O R I S   O R D E R


//  L O A D   B I L L I N G   A C C O U N T
export function loadBillingAccount() {
    return {
        type: OrderTypes.LOAD_BILLING_ACCOUNT,
    };
}

export function loadBillingAccountRes(data) {
    return {
        type: actionCreator(OrderTypes.LOAD_BILLING_ACCOUNT, 'res'),
        data,
    };
}

export function loadBillingAccountErr() {
    return {
        type: actionCreator(OrderTypes.LOAD_BILLING_ACCOUNT, 'err'),
    };
}
//  L O A D   B I L L I N G   A C C O U N T


// A D D  P A Y M E N T  O R D E R
export function addPaymentOrder(data) {
    return {
        type: OrderTypes.ADD_PAYMENT_ORDER,
        data,
    };
}

export function addPaymentOrderRes(loading, success) {
    return {
        type: actionCreator(OrderTypes.ADD_PAYMENT_ORDER, 'res'),
        loading,
        success,
    };
}

export function addPaymentOrderErr() {
    return {
        type: actionCreator(OrderTypes.ADD_PAYMENT_ORDER, 'err'),
    };
}
// A D D  P A Y M E N T  O R D E R


// P A Y M E N T  O R D E R  V I S I B I L I T Y
export function paymentOrderPopupVisibility(data) {
    return {
        type: OrderTypes.PAYMENT_ORDER_POPUP_VISIBILITY,
        data,
    };
}
// P A Y M E N T  O R D E R  V I S I B I L I T Y


// D E L E T E   P A Y M E N T  O R D E R
export function deletePaymentOrder(data) {
    return {
        type: OrderTypes.DELETE_PAYMENT_ORDER,
        data,
    };
}
export function deletePaymentOrderRes(loading, success) {
    return {
        type: actionCreator(OrderTypes.DELETE_PAYMENT_ORDER, 'res'),
        loading,
        success,
    };
}

export function deletePaymentOrderErr() {
    return {
        type: actionCreator(OrderTypes.DELETE_PAYMENT_ORDER, 'err'),
    };
}
// D E L E T E  P A Y M E N T  O R D E R


// L O A D   P A Y M E N T   T Y P E S   O R D E R
export function loadPaymentTypes(data) {
    return {
        type: OrderTypes.LOAD_PAYMENT_TYPES,
        data,
    };
}

export function loadPaymentTypesRes(data) {
    return {
        type: actionCreator(OrderTypes.LOAD_PAYMENT_TYPES, 'res'),
        data,
    };
}

export function loadPaymentTypesErr() {
    return {
        type: actionCreator(OrderTypes.LOAD_PAYMENT_TYPES, 'err'),
    };
}
// L O A D   P A Y M E N T   T Y P E S   O R D E R


// A D D   P A Y M E N T   R E Q U E S T   O R D E R
export function addPaymentRequestOrder(data) {
    return {
        type: OrderTypes.ADD_PAYMENT_REQUEST_ORDER,
        data,
    };
}
export function addPaymentRequestOrderRes(loading, success) {
    return {
        type: actionCreator(OrderTypes.ADD_PAYMENT_REQUEST_ORDER, 'res'),
        loading,
        success,
    };
}

export function addPaymentRequestOrderErr() {
    return {
        type: actionCreator(OrderTypes.ADD_PAYMENT_REQUEST_ORDER, 'err'),
    };
}
// A D D   P A Y M E N T   R E Q U E S T   O R D E R


// P A Y M E N T  R E Q U E S T   O R D E R  V I S I B I L I T Y
export function paymentRequestOrderPopupVisibility(data) {
    return {
        type: OrderTypes.PAYMENT_REQUEST_ORDER_POPUP_VISIBILITY,
        data,
    };
}
// P A Y M E N T  R E Q U E S T   O R D E R  V I S I B I L I T Y


// L O A D   O R D E R   I N V O I C E S
export function loadOrderInvoices(orderId) {
    return {
        type: OrderTypes.LOAD_ORDER_INVOICES,
        orderId,
    };
}

export function loadOrderInvoicesRes(data) {
    return {
        type: actionCreator(OrderTypes.LOAD_ORDER_INVOICES, 'res'),
        data,
    };
}

export function loadOrderInvoicesErr() {
    return {
        type: actionCreator(OrderTypes.LOAD_ORDER_INVOICES, 'err'),
    };
}
// L O A D   O R D E R   I N V O I C E S


// D E L E T E   P R I N T I N G   F I L E
export function deletePrintingFile(data) {
    return {
        type: OrderTypes.DELETE_PRINTING_FILE,
        data,
    };
}
export function deletePrintingFileRes(loading, success) {
    return {
        type: actionCreator(OrderTypes.DELETE_PRINTING_FILE, 'res'),
        loading,
        success,
    };
}

export function deletePrintingFileErr() {
    return {
        type: actionCreator(OrderTypes.DELETE_PRINTING_FILE, 'err'),
    };
}
// D E L E T E   P R I N T I N G   F I L E


// C H A N G E   O R D E R   I T E M   S T A T U S
export function changeOrderItemStatus(data) {
    return {
        type: OrderTypes.CHANGE_ORDER_ITEM_STATUS,
        data,
    };
}
export function changeOrderItemStatusRes(loading, success) {
    return {
        type: actionCreator(OrderTypes.CHANGE_ORDER_ITEM_STATUS, 'res'),
        loading,
        success,
    };
}

export function changeOrderItemStatusErr() {
    return {
        type: actionCreator(OrderTypes.CHANGE_ORDER_ITEM_STATUS, 'err'),
    };
}
// C H A N G E   O R D E R   I T E M   S T A T U S


// C H A N G E   P R I N T I N G   O F F I C E
export function changePrintingOffice(data) {
    return {
        type: OrderTypes.CHANGE_PRINTING_OFFICE,
        data,
    };
}
// C H A N G E   P R I N T I N G   O F F I C E

// P R I N T I N G   O F F I C E   C O N F I R M A T I O N   P O P U P
export function showPrintingOfficePopup() {
    return {
        type: OrderTypes.SHOW_PRINTING_OFFICE_POPUP,
    };
}

export function hidePrintingOfficePopup() {
    return {
        type: OrderTypes.HIDE_PRINTING_OFFICE_POPUP,
    };
}
// P R I N T I N G   O F F I C E   C O N F I R M A T I O N   P O P U P

// E D I T   S H I P P I N G   A D D R E S S
export function editShippingAddress(data) {
    return {
        type: OrderTypes.EDIT_SHIPPING_ADDRESS,
        data,
    };
}

export function editShippingAddressRes(loading, success) {
    return {
        type: actionCreator(OrderTypes.EDIT_SHIPPING_ADDRESS, 'res'),
        loading,
        success,
    };
}

export function editShippingAddressErr() {
    return {
        type: actionCreator(OrderTypes.EDIT_SHIPPING_ADDRESS, 'err'),
    };
}
// E D I T   S H I P P I N G   A D D R E S S

// C H A N G E   B I L L I N G   A C C O U N T
export function changeBillingAccount(data) {
    return {
        type: OrderTypes.CHANGE_BILLING_ACCOUNT,
        data,
    };
}
export function changeBillingAccountRes() {
    return {
        type: actionCreator(OrderTypes.CHANGE_BILLING_ACCOUNT, 'res'),
    };
}
export function changeBillingAccountErr() {
    return {
        type: actionCreator(OrderTypes.CHANGE_BILLING_ACCOUNT, 'err'),
    };
}
// C H A N G E   B I L L I N G   A C C O U N T

// T O G G L E   B I L L I N G   A C C O U N T   P O P U P
export function toggleBillingAccountPopup(data) {
    return {
        type: OrderTypes.TOGGLE_BILLING_ACCOUNT_POPUP,
        data,
    };
}
// T O G G L E   B I L L I N G   A C C O U N T   P O P U P

// S E T   P R I N T   V E R S I O N   D A T A
export function setPrintVersionData(data) {
    return {
        type: OrderTypes.SET_PRINT_VERSION_DATA,
        data,
    };
}
// S E T   P R I N T   V E R S I O N   D A T A

// A D D   P R I N T I N G   F I L E
export function addPrintingFile(data, orderNumber) {
    return {
        type: OrderTypes.ADD_PRINTING_FILE,
        data,
        orderNumber,
    };
}

export function addPrintingFileRes() {
    return {
        type: actionCreator(OrderTypes.ADD_PRINTING_FILE, 'res'),
    };
}

export function addPrintingFileErr() {
    return {
        type: actionCreator(OrderTypes.ADD_PRINTING_FILE, 'err'),
    };
}
// A D D   P R I N T I N G   F I L E

// S E T   V I E W   D E S I G N   V A R I A N T S   P O P U P
export function setViewDesignVariantsPopup(data) {
    return {
        type: OrderTypes.SET_VIEW_DESIGN_VARIANTS_POPUP,
        data,
    };
}
// S E T   V I E W   D E S I G N   V A R I A N T S   P O P U P

// A D D   D I S C O U N T  I N T O   O R D E R
export function addDiscountIntoOrder(data) {
    return {
        type: OrderTypes.ADD_DISCOUNT_INTO_ORDER,
        data,
    };
}

export function addDiscountIntoOrderRes(loading, success) {
    return {
        type: actionCreator(OrderTypes.ADD_DISCOUNT_INTO_ORDER, 'res'),
        loading,
        success,
    };
}

export function addDiscountIntoOrderErr() {
    return {
        type: actionCreator(OrderTypes.ADD_DISCOUNT_INTO_ORDER, 'err'),
    };
}
// A D D   D I S C O U N T  I N T O   O R D E R

// C H A N G E   O R D E R   S T A T U S   T O   W A I T I N G   F O R   P A Y M E N T
export function changeOrderStatusToWaitingForPayment(data) {
    return {
        type: OrderTypes.CHANGE_ORDER_STATUS_TO_WAITING_FOR_PAYMENT,
        data,
    };
}

export function changeOrderStatusToWaitingForPaymentRes(loading, success) {
    return {
        type: actionCreator(OrderTypes.CHANGE_ORDER_STATUS_TO_WAITING_FOR_PAYMENT, 'res'),
        loading,
        success,
    };
}

export function changeOrderStatusToWaitingForPaymentErr() {
    return {
        type: actionCreator(OrderTypes.CHANGE_ORDER_STATUS_TO_WAITING_FOR_PAYMENT, 'err'),
    };
}
// C H A N G E   O R D E R   S T A T U S   T O   W A I T I N G   F O R   P A Y M E N T

// D O W N L O A D   O R D E R   P D F
export function downloadOrderPdf(id) {
    return {
        type: OrderTypes.DOWNLOAD_ORDER_PDF,
        id,
    };
}

export function downloadOrderPdfRes() {
    return {
        type: actionCreator(OrderTypes.DOWNLOAD_ORDER_PDF, 'res'),
    };
}

export function downloadOrderPdfErr() {
    return {
        type: actionCreator(OrderTypes.DOWNLOAD_ORDER_PDF, 'err'),
    };
}
// D O W N L O A D   O R D E R   P D F

// D O W N L O A D   O R D E R   I T E M   P D F
export function downloadOrderItemPdf(id) {
    return {
        type: OrderTypes.DOWNLOAD_ORDER_ITEM_PDF,
        id,
    };
}

export function downloadOrderItemPdfRes() {
    return {
        type: actionCreator(OrderTypes.DOWNLOAD_ORDER_ITEM_PDF, 'res'),
    };
}

export function downloadOrderItemPdfErr() {
    return {
        type: actionCreator(OrderTypes.DOWNLOAD_ORDER_ITEM_PDF, 'err'),
    };
}
// D O W N L O A D   O R D E R   I T E M   P D F
